var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"is-flex"},[_c('div',{staticClass:"border-radius-4 py-1 px-2 mt-1 flex-shrink-0 is-align-self-flex-start",class:_vm.classTagComputed},[_c('p',{staticClass:"label-11 averta-bold",class:_vm.classTitleComputed},[_vm._v(_vm._s(_vm.renderTitle))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }